module.exports = __webpack_public_path__ + "img/office-ikon.b5fdf256.png";